 <template>
    <!-- 商户进件详情 -->
    <div class="companyMerchantNetModify">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <el-form :inline="true" label-position="left">
                <!-- 商户基本信息 -->
                <!-- <template v-if="audit_fail.includes('addr')||audit_fail.includes('area_code')||audit_fail.includes('mcc')"> -->
                <template>
                    <div class="m-title">商户基本信息<span style="color:red;margin-left:20px;">请确认信息无误后提交,并联系客服!</span></div>
                    <el-form-item label="商户经营地址"  style="width:370px;" >
                        <el-select  style="width:90px;"
                            size="medium"
                            v-model="baseInfo.prov_name"
                            filterable
                            @change="handleProChange"
                            placeholder="省"
                        >
                            <el-option
                                v-for="item in proList"
                                :label="item.name"
                                :value="item.code"
                                :key="item.code"
                            ></el-option>
                        </el-select>
                        <el-select style="width:90px;"
                            size="medium"
                            v-model="baseInfo.city_name"
                            filterable
                            @change="handleCityChange"
                            placeholder="市"
                        >
                            <el-option
                                v-for="item in cityList"
                                :label="item.name"
                                :value="item.code"
                                :key="item.code"
                            ></el-option>
                        </el-select>
                        <el-select style="width:90px;"
                            size="medium"
                            v-model="baseInfo.area_name"
                            filterable
                            @change="handleCountyChange"
                            placeholder="区"
                        >
                            <el-option
                                v-for="item in countyList"
                                :label="item.name"
                                :value="item.code"
                                :key="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="详细地址">
                        <el-input  style="width:469px"
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="baseInfo.addr_detail"
                            placeholder="请输入详细地址,至少包含【号、室、组、弄、巷、栋、房、交叉口】其中之一"
                        ></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item label="经营类别" prop="mcc">
                        <el-select
                            size="medium"
                            v-model="baseInfo.custom_code"
                            filterable
                            @change="handleMccChange"
                            placeholder="经营类别"
                        >
                            <el-option
                                v-for="item in mccList"
                                :label="item.name"
                                :value="item.code"
                                :key="item.code"
                            ></el-option>
                        </el-select>
                        <el-select
                            size="medium"
                            v-model="baseInfo.mcc_name"
                            filterable
                            @change="handleMccsChange"
                            placeholder="经营类别"
                        >
                            <el-option
                                v-for="item in mccsList"
                                :label="item.name"
                                :value="item.mcc"
                                :key="item.mcc"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="经营范围" prop="business">
                        <el-input style="width:385px"
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="baseInfo.biz_scope"
                            placeholder="请输入经营范围"
                        ></el-input>
                    </el-form-item>
                </template>
                <!-- 商户法人信息 -->
                <!-- <template v-if="audit_fail.includes('owner_name')||audit_fail.includes('owner_cert_id')||audit_fail.includes('owner_mobile')||audit_fail.includes('owner_cert_sdate')||audit_fail.includes('owner_cert_edate')||audit_fail.includes('fcert_file_id')||audit_fail.includes('bcert_file_id')||audit_fail.includes('hcert_file_id')"> -->
                <template>
                    <div class="m-title">商户法人信息&nbsp;&nbsp;<span style="font-size:12px;color:red;">【身份证正反面/手持照/结算照不可模糊】</span></div>
                    <div v-loading="imgLoading" element-loading-text="图片上传中,请稍等...." >
                        <el-form-item label="法人身份证正面照" style="display: inline-grid;" label-position="left" label-width="170px">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleFrontIdCardImg"
                            >
                                <img
                                    v-if="ownerInfo.card_positive_img_path != ''"
                                    :src="ownerInfo.card_positive_img_path"
                                    class="avatar"
                                />
                                <img
                                    v-else
                                    :src="require('../../assets/images/idcard_f3x.png')"
                                    class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="法人身份证反面照" style="display: inline-grid;"  label-position="left" label-width="170px">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleBackIdCardImg"
                            >
                                <img
                                    v-if="ownerInfo.card_negative_img_path != ''"
                                    :src="ownerInfo.card_negative_img_path"
                                    class="avatar"
                                />
                                <img
                                    v-else
                                    :src="require('../../assets/images/idcard_r3x.png')"
                                    class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="手持身份证照" style="display: inline-grid;"  label-position="left" label-width="150px">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleCardHandHoldImg"
                            >
                                <img
                                    v-if="ownerInfo.card_hand_hold_img_path != ''"
                                    :src="ownerInfo.card_hand_hold_img_path"
                                    class="avatar"
                                />
                                <img
                                    v-else
                                    :src="require('../../assets/images/hand_hold.jpg')"
                                    class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                    </div>
                    <el-form-item label="法人姓名">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="ownerInfo.legal_person"
                            placeholder="请输入法人姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="法人手机号">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="ownerInfo.legal_phone"
                            placeholder="请输入法人手机号"
                        ></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item label="证件号">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="ownerInfo.id_card"
                            placeholder="请输入证件号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="证件有效期">
                        <el-date-picker
                            v-model="cardRange"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            :disabled="isSelect"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="handleCardChange"
                        ></el-date-picker>
                        <span style="margin-left:10px">
                            <el-checkbox
                                :true-label="1"
                                :false-label="0"
                                :disabled="ownerInfo.card_valid_sdate == ''"
                                @change="handleCheckboxChange"
                                v-model="is_long_time"
                            >长期</el-checkbox>
                        </span>
                    </el-form-item>
                </template>
                <!-- 营业执照信息 -->
                <!-- <template >
                    <el-form-item label="营业执照信息" prop="owner_cert_sdate">
                        <el-date-picker
                            v-model="cardRange"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            :disabled="isSelect"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            @change="handleCardChange"
                        ></el-date-picker>
                        <span style="margin-left:10px">
                            <el-checkbox
                                :true-label="1"
                                :false-label="0"
                                :disabled="agentForm.owner_cert_sdate == ''"
                                @change="handleCheckboxChange"
                                v-model="agentForm.is_long_time"
                            >长期</el-checkbox>
                        </span>
                    </el-form-item>
                </template> -->
                <!-- 结算基本信息 -->
                <!-- <template >
                    <div class="m-title">结算基本信息<span style="color:red;margin-left:20px;">请确认信息无误后提交,并联系客服!</span></div>
                    <el-form-item label="商户经营地址">
                        <el-cascader
                            separator="-"
                            filterable
                            :options="areaList"
                            :props="cascaderProps"
                            placeholder="请选择商户经营地址"
                            @change="handleAreaChange"
                        ></el-cascader>
                        &nbsp;&nbsp;&nbsp;<span style="font-size:12px">{{agentForm.view_business_addr}}-</span>
                    </el-form-item>

                    <el-form-item label="" prop="addr_detail">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.addr_detail"
                            placeholder="请输入详细地址"
                        ></el-input>
                    </el-form-item>
                </template> -->
                <!-- 图片资料信息 -->
                <!-- <template >
                    <div class="m-title">图片资料信息<span style="color:red;margin-left:20px;">请确认信息无误后提交,并联系客服!</span></div>
                    <el-form-item label="商户经营地址">
                        <el-cascader
                            separator="-"
                            filterable
                            :options="areaList"
                            :props="cascaderProps"
                            placeholder="请选择商户经营地址"
                            @change="handleAreaChange"
                        ></el-cascader>
                        &nbsp;&nbsp;&nbsp;<span style="font-size:12px">{{agentForm.view_business_addr}}-</span>
                    </el-form-item>

                    <el-form-item label="" prop="addr_detail">
                        <el-input
                            size="medium"
                            suffix-icon="el-icon-aux"
                            v-model="agentForm.addr_detail"
                            placeholder="请输入详细地址"
                        ></el-input>
                    </el-form-item>
                </template> -->
        </el-form>
            <div style="margin-top:20px">
                <el-button
                    type="primary"
                    :loading="loading"
                    style="font-size: 12px;"
                    @click="handleSubmit(agentForm)"
                >保存设置</el-button>
            </div>
    </div>
</template>

<script>
import imageViwe from '../../../node_modules/element-ui/packages/image/src/image-viewer';
import areaList from '../../utils/area';
import searchRegion from '../../utils/searchRegion';
export default {

    data() {
        return {
            loading: false, // 提交loading
            imgLoading: false,  // 上传图片loading
            uploadUrl: this.$api.uploadUrl, // 上传图片的地址
            imgLoading: false, // 上传图片loading
            proList:[],
            cityList:[],
            countyList:[],
            mccList:[],         // mcc
            mccsList:[],
            cardRange: [],      // 身份证有效期
            isSelect: false,    // 根据是否选中长期来判断身份证截止日期是否可选
            is_long_time: 0,                // 是否长期 身份证
            baseInfo: {
                prov_code:"",               // 省代码
                city_code:"",               // 市代码
                area_code:"",               // 区代码
                prov_name:"",               // 省
                city_name:"",               // 市
                area_name:"",               // 区
                view_business_addr:'',      // 省市区
                addr_detail:"",             // 详细地址
                union_pay_code:'',
                custom_code:'', //经营类别
                mcc:'',
                mcc_name:'',
                biz_scope:'',
            },
            ownerInfo: {
                card_positive_img: '',      // 身份证正面
                card_positive_img_path: '', // 身份证正面--展示
                card_negative_img: '',      // 身份证反面
                card_negative_img_path: '', // 身份证反面--展示
                card_hand_hold_img:'',      // 手持身份证
                card_hand_hold_img_path:'', // 手持身份证--展示
                legal_phone: '',            // 法人手机号
                id_card: '',                // 身份证
                card_valid_sdate: '',       // 身份证开始时间
                card_valid_edate: '',       // 身份证结束时间
                legal_person: '',           // 法人
            },
            credit_code:"",
            mch_type:"0",
            audit_fail:"",
            id:this.$route.query.m_id,//公司id 
        }
    },
    created() {
        // this.getBank(); //获取银行列表
        // this.getAddress(); //获取地址列表
        this.getMcc(); //获取初始信息
        this.getProAddress(); //获取地址列表
        this.getinit(); //获取初始信息

    },
    mounted() {

    },
    methods: {
        // 进件失败时
        handleSubmit() { //后台提交
            this.loading = true; //防重复
            this.$api.post('merchant_company/modifyCompanyMerchantNet', {baseInfo:this.baseInfo}, res => {
                let that = this;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 1500,
                        onClose() {
                            that.loading = false;
                        }
                    });
                    this.getinit();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg,
                        duration: 1500,
                        onClose() {
                            that.loading = false;
                        }
                    });
                }
            })
        },
        getinit() { // 获取初始信息
            this.$api.post("merchant_company/getOneCompanyMerchant", {id:this.id}, res => {
                if (res.code == 0) {
                    this.mch_type=res.data.merchant_type;
                    this.credit_code=res.data.license_no;
                    this.audit_fail=res.data.audit_fail;
                    this.baseInfo.biz_scope=res.data.biz_scope;
                    this.baseInfo.prov_code=res.data.prov_code;               // 省代码
                    this.baseInfo.city_code=res.data.city_code;               // 市代码
                    this.baseInfo.area_code=res.data.area_code;               // 区代码
                    this.baseInfo.prov_name=res.data.prov_name;               // 省代码
                    this.baseInfo.city_name=res.data.city_name;               // 市代码
                    this.baseInfo.area_name=res.data.area_name;               // 区代码
                    this.baseInfo.addr_detail=res.data.addr_detail;           // 详细地址
                    this.baseInfo.biz_scope=res.data.biz_scope;           // 详细地址
                    this.baseInfo.mcc=res.data.mcc;
                    this.baseInfo.union_pay_code=res.data.union_pay_code;
                    this.baseInfo.view_business_addr=res.data.view_business_addr;

                    this.ownerInfo.card_positive_img=res.data.card_positive_photo;       // 身份证正面
                    this.ownerInfo.card_positive_img_path=res.data.card_positive_photo_path;  // 身份证正面--展示
                    this.ownerInfo.card_negative_img=res.data.card_negative_photo;       // 身份证反面
                    this.ownerInfo.card_negative_img_path=res.data.card_negative_photo_path;  // 身份证反面--展示
                    this.ownerInfo.card_hand_hold_img=res.data.card_hand_hold_photo;       // 手持身份证
                    this.ownerInfo.card_hand_hold_img_path=res.data.card_hand_hold_photo_path;  // 手持身份证--展示
                    this.ownerInfo.legal_phone=res.data.owner_mobile;            // 法人手机号
                    this.ownerInfo.id_card=res.data.owner_cert_id;               // 身份证

                    this.ownerInfo.legal_person=res.data.owner_name;           // 法人
                    if(res.data.owner_cert_edate){
                        this.ownerInfo.card_valid_sdate=res.data.owner_cert_sdate;       // 身份证开始时间
                        this.ownerInfo.card_valid_edate=res.data.owner_cert_edate;       // 身份证结束时间
                        this.cardRange=[res.data.owner_cert_sdate,res.data.owner_cert_edate];      // 身份证有效期
                        if(res.data.owner_cert_edate=="9999-12-31"){
                            this.isSelect=true;
                            this.is_long_time=1;
                        }
                    };
                    this.getMcc1(res.data.mcc); //获取MCC列表
                    // this.getCompanyMerchantNetCache(); //获取缓存信息
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleCheckboxChange(value) { // 处理是否长期
            if (value == 1) {
                this.isSelect = true;
                if (this.cardRange.length) { // 已选择有效期后进行修改
                    this.cardRange = [this.cardRange[0], '9999-12-31'];
                    this.agentForm.card_valid_edate = '9999-12-31';
                }
            } else {
                this.isSelect = false;
                if (this.cardRange.length) {
                    this.cardRange = [this.cardRange[0], this.$moment(Date.now()).format('YYYY-MM-DD')];
                    this.agentForm.card_valid_edate = '';
                }
            }
        },
        getMcc() { // 获取mcc列表
            this.$api.post("MerchantNet/getMcc", {}, res => {
                if (res.code == 0) {
                    this.mccList = res.data;
                }
            })
        },
        getMcc1(mcc) { // 获取mcc列表
            this.$api.post("MerchantNet/getMcc", {custom_code:1,is_personal:this.mch_type}, res => {
                let bank = res.data.filter(item => {
                return item.mcc == mcc;
                });
                this.baseInfo.custom_code = bank[0].custom_code;
                this.baseInfo.mcc_name = bank[0].name;
                // if (res.code == 0) {
                //     this.mccList = res.data;
                // }
            })
        },
        handleMccChange(bankVal) { // 处理银行选中时获取值
            this.mccsList=[];
            this.baseInfo.mcc_name='';
            this.$api.post("MerchantNet/getMcc", {custom_code:bankVal,is_personal:this.mch_type}, res => {
                if (res.code == 0) {
                    this.mccsList = res.data;
                }
            })
        },
        handleMccsChange(bankVal) { // 处理银行选中时获取值
           let bank = this.mccsList.filter(item => {
                return item.mcc == bankVal;
            });
            this.baseInfo.mcc_name = bank[0].name;
            this.baseInfo.mcc = bank[0].mcc;
        },
        getProAddress() { // 获取银行省列表
            this.$api.post("MerchantNet/getAddr", {}, res => {
                if (res.code == 0) {
                    this.proList = res.data;
                }
            })
        },
        handleProChange(bankVal) { // 处理省选中时获取值
            console.log(bankVal)
            let bank = this.proList.filter(item => {
                return item.code == bankVal;
            });
            this.baseInfo.prov_name = bank[0].name;
            this.baseInfo.prov_code = bank[0].code;
            this.cityList=[];
            this.countyList=[];
            this.$api.post("MerchantNet/getAddr", {parent_code:bankVal}, res => {
                if (res.code == 0) {
                    this.cityList = res.data;
                }
            })
        },
        handleCityChange(bankVal) { // 处理市选中时获取值
            let bank = this.cityList.filter(item => {
                return item.code == bankVal;
            });
            this.baseInfo.city_name = bank[0].name;
            this.baseInfo.city_code = bank[0].code;
            this.countyList=[];
            this.$api.post("MerchantNet/getAddr", {parent_code:bankVal}, res => {
                if (res.code == 0) {
                    this.countyList = res.data;
                }
            })
        },
        handleCountyChange(bankVal) { // 处理区选中时获取值
            let bank = this.countyList.filter(item => {
                return item.code == bankVal;
            });
            this.baseInfo.area_name = bank[0].name;
            this.baseInfo.area_code = bank[0].code;
            this.baseInfo.union_pay_code = bank[0].union_pay_code;
            this.baseInfo.view_business_addr=this.baseInfo.prov_name+"-"+this.baseInfo.city_name+"-"+this.baseInfo.area_name;
        },
        getCompanyMerchantNetCache() { // 获取redis信息
            this.$api.post("merchant_company/getCompanyMerchantNetCache", {license_no:this.baseInfo.credit_code,mch_type:this.baseInfo.mch_type}, res => {
                if (res.code == 0) {
                    if(res.data.agentForm){
                        var list=res.data.agentForm;
                        // if(list.card_positive_img){this.agentForm.card_positive_img=list.card_positive_img;this.agentForm.card_positive_img_path=list.card_positive_img_path;};      // 身份证正面
                        // if(list.card_negative_img){this.agentForm.card_negative_img=list.card_negative_img;this.agentForm.card_negative_img_path=list.card_negative_img_path;};      // 身份证反面
                        // if(list.bus_license_img){this.agentForm.bus_license_img=list.bus_license_img;this.agentForm.bus_license_img_path=list.bus_license_img_path;};      // 营业执照
                        // if(list.opening_permit_img){this.agentForm.opening_permit_img=list.opening_permit_img;this.agentForm.opening_permit_img_path=list.opening_permit_img_path;};      // 开户许可照片
                        // if(list.card_hand_hold_img){this.agentForm.card_hand_hold_img=list.card_hand_hold_img;this.agentForm.card_hand_hold_img_path=list.card_hand_hold_img_path;};      // 手持身份证
                        // if(list.settle_card_img){this.agentForm.settle_card_img=list.settle_card_img;this.agentForm.settle_card_img_path=list.settle_card_img_path;};      // 结算银行卡


                        if(list.store_door_img){this.agentForm.store_door_img=list.store_door_img;this.agentForm.store_door_img_path=list.store_door_img_path;};      // 结算银行卡
                        if(list.store_environment_img){this.agentForm.store_environment_img=list.store_environment_img;this.agentForm.store_environment_img_path=list.store_environment_img_path;};      // 结算银行卡
                        // if(list.merchant_contract_img){this.agentForm.merchant_contract_img=list.merchant_contract_img;this.agentForm.merchant_contract_img_path=list.merchant_contract_img_path;};      // 结算银行卡
                        if(list.statement_settlement_img){this.agentForm.statement_settlement_img=list.statement_settlement_img;this.agentForm.statement_settlement_img_path=list.statement_settlement_img_path;};      // 结算银行卡
                        if(list.other_documents_img){this.agentForm.other_documents_img=list.other_documents_img;this.agentForm.other_documents_img_path=list.other_documents_img_path;};      // 结算银行卡
                        if(list.handwritten_signature_img){this.agentForm.handwritten_signature_img=list.handwritten_signature_img;this.agentForm.handwritten_signature_img_path=list.handwritten_signature_img_path;};      // 结算银行卡
                        if(list.signing_documents_img){this.agentForm.signing_documents_img=list.signing_documents_img;this.agentForm.signing_documents_img_path=list.signing_documents_img_path;};      // 结算银行卡
                        if(list.store_cashier_img){this.agentForm.store_cashier_img=list.store_cashier_img;this.agentForm.store_cashier_img_path=list.store_cashier_img_path;};      // 结算银行卡
                        if(list.securities_img){this.agentForm.securities_img=list.securities_img;this.agentForm.securities_img_path=list.securities_img_path;};      // 结算银行卡

                        if(list.mch_type){this.agentForm.mch_type=list.mch_type;};      // 商户角色
                        if(list.mch_name){this.agentForm.mch_name=list.mch_name;};      // 商户名称
                        if(list.legal_person){this.agentForm.legal_person=list.legal_person;};      // 法人
                        if(list.legal_phone){this.agentForm.legal_phone=list.legal_phone;};      // 法人手机号
                        if(list.id_card){this.agentForm.id_card=list.id_card;};      // 身份证
                        if(list.card_valid_edate){
                            this.agentForm.card_valid_sdate=list.card_valid_sdate;// 身份证开始时间
                            this.agentForm.card_valid_edate=list.card_valid_edate;// 身份证结束时间
                            this.cardRange=[list.card_valid_sdate,list.card_valid_edate];      // 身份证有效期
                            if(list.card_valid_edate=="9999-12-31"){
                                this.isSelect=true;
                                this.is_long_time=1;
                            }
                        };

                        if(list.prov_code){
                            this.agentForm.prov_code=list.prov_code;
                            this.$api.post("MerchantNet/getAddr", {parent_code:list.prov_code}, res => {
                                if (res.code == 0) {
                                    this.countyList = res.data;
                                }
                            })
                        };      // 省代码
                        if(list.city_code){
                            this.agentForm.city_code=list.city_code;
                            this.$api.post("MerchantNet/getAddr", {parent_code:list.city_code}, res => {
                                if (res.code == 0) {
                                    this.countyList = res.data;
                                }
                            })
                        };      // 市代码
                        if(list.area_code){this.agentForm.area_code=list.area_code;};      // 区代码
                        if(list.prov_name){this.agentForm.prov_name=list.prov_name;};      // 省
                        if(list.city_name){this.agentForm.city_name=list.city_name;};      // 市
                        if(list.area_name){this.agentForm.area_name=list.area_name;};      // 区
                        if(list.view_business_addr){this.agentForm.view_business_addr=list.view_business_addr;};      // 省市区
                        if(list.addr_detail){this.agentForm.addr_detail=list.addr_detail;};      // 详细地址
                        if(list.union_pay_code){this.agentForm.union_pay_code=list.union_pay_code;};      // 地区码

                        if(list.credit_code){this.agentForm.credit_code=list.credit_code;};      // 营业执照信用代码
                        if(list.reg_capital){this.agentForm.reg_capital=list.reg_capital;};      // 注册资本
                        if(list.business){this.agentForm.business=list.business;};      // 经营范围
                        if(list.mcc){
                            this.agentForm.mcc_name=list.mcc_name;
                            this.agentForm.custom_code=list.custom_code;
                            this.agentForm.mcc=list.mcc;
                            this.$api.post("MerchantNet/getMcc", {custom_code:list.custom_code,is_personal:list.mch_type}, res => {
                                if (res.code == 0) {
                                    this.mccsList = res.data;
                                }
                            })
                        };      // 地区码
                        if(list.bus_license_valid_edate){
                            this.agentForm.bus_license_valid_sdate=list.bus_license_valid_sdate;// 营业执照开始时间
                            this.agentForm.bus_license_valid_edate=list.bus_license_valid_edate;// 营业执照结束时间
                            this.licenseRange=[list.bus_license_valid_sdate,list.bus_license_valid_edate];      // 营业执照有效期
                            if(list.bus_license_valid_edate=="9999-12-31"){
                                this.isSelect2=true;
                                this.is_bus_license_long_time=1;
                            }
                        };

                        if(list.legal_company){this.agentForm.legal_company=list.legal_company;};      // 账户名
                        if(list.account_name){this.agentForm.account_name=list.account_name;};      // 账户名
                        if(list.bank_name){this.agentForm.bank_name=list.bank_name;};      // 银行名称
                        if(list.account_type){
                            this.agentForm.account_type=list.account_type;
                        };      // 银行名称

                        if(list.bank_code){this.agentForm.bank_code=list.bank_code;};      // 银行卡号
                        if(list.branch_bank){this.agentForm.branch_bank=list.branch_bank;};      // 分行名
                        if(list.bankSign && list.bank_prov){
                            this.$api.post('bank/branch', { bank_symbol: list.bankSign, bank_prov: list.bank_prov}, res => {
                                if (res.code == 0) {
                                    this.agentForm.line_num = '';
                                    this.branchList = [];
                                    this.branchList = res.data.bank;
                                    if(list.line_num){this.agentForm.line_num=list.line_num;};      // 联行号
                                    if(list.bank_prov){this.agentForm.bank_prov=list.bank_prov;};      // 银行所在省
                                    if(list.bankSign){this.agentForm.bankSign=list.bankSign;};      // 银行所在省
                                } else {
                                    this.$message.error('获取支行信息失败，请重新选择银行或归属地进行获取!');
                                }
                            });
                        }
                    }
                }else{
                    this.getCompanyRate(); //获取MCC列表
                }
            })
        },
        handleLicenseChange(dateArr) { // 营业执照有效期处理
            if (dateArr) {
                this.licenseInfo.bus_license_valid_sdate = dateArr[0];
                this.licenseInfo.bus_license_valid_edate = dateArr[1];
            }
        },
        handleCardChange(dateArr) { // 身份证有效期处理
            if (dateArr) {
                this.ownerInfo.card_valid_sdate = dateArr[0];
                this.ownerInfo.card_valid_edate = dateArr[1];
            }
        },
        handleImgLoading() { // 上传文件时加载loading
            this.imgLoading = true;
        },
        handleFrontIdCardImg(res) { // 身份证正面
            this.upImg({
                res,
                path: 'card_positive_img',
                img: 'card_positive_img_path'
            },1);
        },
        handleBackIdCardImg(res) { // 身份证反面
            this.upImg({
                res,
                path: 'card_negative_img',
                img: 'card_negative_img_path'
            },2);
        },
        handleCardHandHoldImg(res) { // 手持身份证
            this.upImg({
                res,
                path: 'card_hand_hold_img',
                img: 'card_hand_hold_img_path'
            },0);
        },
        handleBusinessLicenseImg(res) { // 营业执照
            this.upImg({
                res,
                path: 'bus_license_img',
                img: 'bus_license_img_path'
            },3);
        },

        handleSettleCardImg(res) { // 结算银行卡
            this.upImg({
                res,
                path: 'settle_card_img',
                img: 'settle_card_img_path'
            },4);
        },
        handleOpenAccountImg(res) { // 开户许可证
            this.upImg({
                res,
                path: 'opening_permit_img',
                img: 'opening_permit_img_path'
            },0);
        },

        handleStoreDoorImg(res) { // 门店门头照
            this.upImg({
                res,
                path: 'store_door_img',
                img: 'store_door_img_path'
            },0);
        },
        handleStoreEnvironmentImg(res) { // 店内环境照片
            this.upImg({
                res,
                path: 'store_environment_img',
                img: 'store_environment_img_path'
            },0);
        },
        handleMerchantContractImg(res) { // 商户合同文件
            this.upFile(res);
        },
        handleStatementSettlementImg(res) { // 结算声明
            this.upImg({
                res,
                path: 'statement_settlement_img',
                img: 'statement_settlement_img_path'
            },0);
        },
        handleOtherDocumentsImg(res) { // 其他文件
            this.upImg({
                res,
                path: 'other_documents_img',
                img: 'other_documents_img_path'
            },0);
        },
        handleHandwrittenSignatureImg(res) { // 手写签名
            this.upImg({
                res,
                path: 'handwritten_signature_img',
                img: 'handwritten_signature_img_path'
            },0);
        },
        handleSigningDocumentsImg(res) { // 签约文件照片
            this.upImg({
                res,
                path: 'signing_documents_img',
                img: 'signing_documents_img_path'
            },0);
        },
        handleStoreCashierImg(res) { // 门店收银台
            this.upImg({
                res,
                path: 'store_cashier_img',
                img: 'store_cashier_img_path'
            },0);
        },
        handleSecuritiesImg(res) { // 经营场所产权证明
            this.upImg({
                res,
                path: 'securities_img',
                img: 'securities_img_path'
            },0);
        },
        upImg(res,type) { //公用
            let resData = res.res;
            if (resData.code === 0) {
                this.ownerInfo[res.img] = resData.data.file_url; //展示路径
                this.ownerInfo[res.path] = resData.data.file_path //请求路径
                this.$api.OCR_POST("getPhotoInfo", {image:resData.data.file_url,type:type}, res => {
                    if (res.code == 0) {
                        if(type==1){
                            this.ownerInfo.id_card=res.data.num;
                        }
                        if(type==2){
                            this.cardRange = [res.data.start_date, res.data.end_date];
                            this.ownerInfo.card_valid_sdate=res.data.start_date;
                            this.ownerInfo.card_valid_edate=res.data.end_date;
                            if(res.data.end_date=="9999-12-31"){
                                this.isSelect = true;
                                this.is_long_time=1;
                            }else{
                                this.isSelect = false;
                                this.is_long_time=0;
                            }
                        }
                        // if(type==3){ 
                        //     this.agentForm.bus_license_valid_sdate=res.data.establish_date;
                        //     this.agentForm.bus_license_valid_edate=res.data.valid_period;
                        //     this.agentForm.business=res.data.business;
                        //     this.licenseRange= [res.data.establish_date, res.data.valid_period];
                        //     this.agentForm.credit_code=res.data.reg_num;
                        //     this.agentForm.addr_detail=res.data.address;
                        //     if(this.agentForm.account_type=='0'){//对私
                        //         this.agentForm.account_name=res.data.person;
                        //     }
                        //     if(this.agentForm.account_type=='2'){//对公
                        //         this.agentForm.account_name=res.data.name;
                        //     }
                        //     this.agentForm.legal_person=res.data.person;
                        //     this.agentForm.legal_company=res.data.name;
                        //     if(res.data.valid_period=="9999-12-31"){
                        //         this.isSelect2 = true;
                        //         this.is_bus_license_long_time=1;
                        //     }else{
                        //         this.isSelect2 = false;
                        //         this.is_bus_license_long_time=0;
                        //     }
                        // }
                        // if(type==4){
                        //     this.agentForm.bank_code=res.data.card_num;
                        // }card_num
                    }
                })
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
            this.imgLoading = false;
        },
        upFile(res) { //公用
            if (res.code === 0) {
                this.merchant_contract_img = res.data.file_url; //展示路径
                this.merchant_contract_img_path = res.data.file_path //请求路径
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
            this.imgLoading = false;
        },
    }
}
</script>

<style scoped lang="scss">
.companyMerchantNetModify {
    font-size: 12px;
    .el-form-item {
        margin-bottom: 22px;
    }
    .m-title {
        color: #303133;
        font-size: 14px;
        font-weight: 700;
        padding-left: 10px;
        margin: 10px 0;
        border-left: 4px solid #409eff;
    }
    .img_path{
        width: 25%;
        display: grid;
    }
    .line {
        text-align: center;
    }
    ::v-deep .el-input-group__append {
        color: #ffffff;
        font-size: 12px;
        background-color: #409eff;
    }

    .avatar-uploader {
        width: 200px;
        height: 130px;
        border-radius: 10px;
        overflow: hidden;
    }
    ::v-deep .avatar-uploader .el-upload {
        width: 100%;
        height: 100%;
    }
    .avatar {
        width: 100%;
        height: 100%;
    }
}
</style>